import {
  Box,
  FormHelperText,
  Typography,
  // Grid2 as Grid,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import UploadNocDocumentComponent from "./UploadNocDocumentComponent";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const CreateNocBanner = ({
  setOnBanner,
  currentProcessingFile,
  setCurrentProcessingFile,
  loadInitNoc,
  discardNocLoading,
  handleDiscardInitNoc,
  initNocLoading,
  handleLoadInitNoc,
  checkInitLoading,
}) => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession].user);

  const navigate = useNavigate();

  const handleOptionChange = (event) => {
    const { name, checked } = event.target;
    setCurrentProcessingFile((prevFile) => ({
      ...prevFile,
      document: {
        ...prevFile.document,
        actions: {
          ...prevFile.document.actions,
          [name]: checked,
        },
      },
    }));
  };

  useEffect(() => {
    if (currentUser) {
      if (currentUser?.user?.expired === true) {
        navigate("/subscription");
      }
    }
  }, [currentUser, navigate]);

  // const [infoMessage, setInfoMessage] = useState("");
  const [uploaderLoading, setUploaderLoading] = useState(false);

  // const notaryOnly =
  //   "Once you upload your form, you’ll just mark where the notary seal and signature go, along with the spot for the property owner’s signature. No worries—it’s super simple, and we’ve got your back. Here’s a quick video to walk you through it like a true Permit Rockstar.";
  // const notaryRecord =
  //   "Once you upload your form, we’ll guide you through marking where the notary seal, notary signature, and property owner’s signature should go—easy stuff. After that, you’ll review the details for validation, approve everything, and make your payment. Then we take it from there, submitting it straight to the correct county Clerk of Courts for recording.And don’t worry—we’ve made it super simple. Here’s a quick video to show you how it’s done, Rockstar-style.";
  // const recordOnly =
  //   "Once you upload your document, we’ll highlight exactly what needs your review. Give it a quick check, hit approve, make your payment—and boom, we’ll submit it straight to the right county Clerk of Courts for recording. Fast, smooth, and handled like a Rockstar.";

  // useEffect(() => {
  //   if (
  //     currentProcessingFile?.document?.actions?.notarize &&
  //     !currentProcessingFile?.document?.actions?.record
  //   ) {
  //     setInfoMessage(notaryOnly);
  //   } else if (
  //     currentProcessingFile?.document?.actions?.record &&
  //     !currentProcessingFile?.document?.actions?.notarize
  //   ) {
  //     setInfoMessage(recordOnly);
  //   } else if (
  //     currentProcessingFile?.document?.actions?.notarize &&
  //     currentProcessingFile?.document?.actions?.record
  //   ) {
  //     setInfoMessage(notaryRecord);
  //   } else {
  //     setInfoMessage("");
  //   }
  // }, [currentProcessingFile]);

  return (
    <>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 2,
          bgcolor: "white",
          p: 2,
        }}
      >
        <Typography align="center" variant="h4" color="primary">
          Let's Get Your NOC Ready
        </Typography>
      </Box>

      {/* Scrollable Content */}
      <Box sx={{ flexGrow: 1, overflowY: "auto", px: 2 }}>
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <img
            alt="avatar_circle"
            src="/img/logos/logo_main.png"
            style={{ width: "13rem", height: "auto", zIndex: 2 }}
          />
        </Box>
        <Typography align="center" variant="h6" color="primary">
          What would you like to do with your NOC?
        </Typography>
        <Box
          align="center"
          sx={{
            mx: "auto",
            display: "flex",
            mb: 2,
            justifyContent: "space-around",
          }}
        >
          {["notarize", "record"]?.map((option, i) => (
            <Box
              key={option}
              sx={{
                ml: i === 0 ? "auto" : undefined,
                mr: i === 1 ? "auto" : undefined,
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={
                      loadInitNoc ||
                      uploaderLoading ||
                      checkInitLoading ||
                      false
                    }
                    checked={
                      currentProcessingFile?.document?.actions?.[option] ??
                      false
                    }
                    onChange={handleOptionChange}
                    name={option}
                  />
                }
                label={option.charAt(0).toUpperCase() + option.slice(1)}
              />
            </Box>
          ))}
        </Box>

        <Typography
          mb={checkInitLoading ? 0 : -3}
          align="center"
          variant="body2"
          fontWeight="bold"
        >
          Upload your Notice of Commencement file, so we can help you get it
          ready.
        </Typography>

        {checkInitLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <CircularProgress color="primary" size="5rem" />
          </Box>
        ) : loadInitNoc ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              mt: 5,
              pt: 2,

              borderTop: "3px solid #f3f3f3",
            }}
          >
            <Typography color="secondary" align="center" variant="h6">
              You’ve already uploaded and started preparing your Notice of
              Commencement form. Would you like to continue from where you left
              off, or discard it and start a new one?
            </Typography>

            <FormHelperText sx={{ color: "primary.main" }}>
              <Typography component="span" variant="body2" fontWeight="bold">
                Warning:&nbsp;
              </Typography>
              If you discard this document, your current progress will be lost
              and cannot be recovered.
            </FormHelperText>

            <Box
              sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 4 }}
            >
              <LoadingButton
                disabled={initNocLoading}
                loading={discardNocLoading}
                onClick={handleDiscardInitNoc}
                color="error"
                sx={{ minWidth: "10rem" }}
                variant="outlined"
              >
                Discard
              </LoadingButton>
              <LoadingButton
                disabled={discardNocLoading}
                loading={initNocLoading}
                onClick={handleLoadInitNoc}
                sx={{ minWidth: "10rem" }}
                variant="contained"
              >
                Continue
              </LoadingButton>
            </Box>
          </Box>
        ) : (
          <UploadNocDocumentComponent
            currentProcessingFile={currentProcessingFile}
            setCurrentProcessingFile={setCurrentProcessingFile}
            // setAddingNewDocument={setAddingNewDocument}
            setOnBanner={setOnBanner}
            uploaderLoading={uploaderLoading}
            setUploaderLoading={setUploaderLoading}
          />
        )}
      </Box>
    </>
  );
};

export default CreateNocBanner;
